<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" md="4" lg="4" class="pb-0">
        <v-select
          label="Filter By Vessel"
          placeholder="Select a vessel"
          outlined
          dense
          v-model="vesselName"
          prepend-inner-icon="mdi-filter"
          :items="vesselNames"
          item-text="name"
          item-value="id"
          @change="applyFilter({vessel_id: $event || null})"
          :loading="vesselLoading"
          clearable
        >
          <template v-slot:prepend-item>
            <v-text-field
              v-model="vesselSearch"
              prepend-inner-icon="mdi-magnify"
              placeholder="Search vessels..."
              clearable
              class="px-4"
              @input="onVesselSearch"
            ></v-text-field>
          </template>
        </v-select>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="4" class="pb-0">
        <v-select
          label="Filter By Date Range Type"
          placeholder="Select a date range type"
          outlined
          dense
          v-model="dateRangeType"
          prepend-inner-icon="mdi-calendar"
          :items="dateRangeTypes"
          item-text="name"
          item-value="id"
          @change="applyFilter({date_range_type: $event})"
        ></v-select>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="4" class="pb-0">
        <v-dialog
          ref="dialog"
          v-model="modal"
          :return-value.sync="dates"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateRangeText"
              label="Select date range"
              prepend-inner-icon="mdi-calendar"
              readonly
              outlined
              hide-details
              dense
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            id="dateRangePicker"
            v-model="dates"
            range
            @change="applyFilter({ date_range: voyageDateRangeForApi })"
          >
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              @click="modal = false"
            >
              Cancel
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.dialog.save(dates)"
            >
              OK
            </v-btn>
          </v-date-picker>
        </v-dialog>
      </v-col>
    </v-row>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        :loading="loading || vesselLoading"
        :sort-by="['id']"
        :sort-desc="[true]"
      >
        <template v-slot:item.fda="{ item }">
          <v-btn
            small
            color="primary"
            :disabled="vesselLoading"
            @click="navigateOperation('FDA', item)"
          >
            Open Job
          </v-btn>
        </template>
        <template v-slot:item.pda="{ item }">
          <v-btn
            small
            color="primary"
            :disabled="vesselLoading"
            @click="navigateOperation('PDA', item)"
          >
            Create PDA
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
  import moment from 'moment';
  import moment_timezone from 'moment-timezone';
  import { ensureSelectedVesselInList } from '../../utilities/vesselHelpers';

  export default {
    name: 's-vessel-voyages',
    data() {
      return {
        search: '',
        loading: false,
        vesselLoading: false,
        headers: [
          {text: 'Id', value: 'id', align: 'start'},
          {text: 'Name', value: 'vessel_name', align: 'start'},
          {text: 'Location From', value: 'location_from', align: 'center'},
          {text: 'Location To', value: 'location_to', align: 'center'},
          {text: 'Estimated Arrival Time', value: 'formatted_dueto_arrive_time', align: 'center'},
          {text: 'Actual Arrival Time', value: 'formatted_arrived_time', align: 'center'},
          {text: 'Estimated Departure Time', value: 'formatted_dueto_depart', align: 'center'},
          {text: 'Actual Departure Time', value: 'formatted_departed_time', align: 'center'},
          {text: 'Open Job', value: 'fda', align: 'center'},
          {text: 'Job PDA', value: 'pda', align: 'center'},
        ],
        items: [],
        vesselName: null,
        vesselNames: [],
        vessels: [],
        customers: [],
        card_id: '',
        dates: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
        modal: false,
        vesselSearch: '',
        vesselSearchTimeout: null,
        filters: {
          date_range_type: 'dueto_arrive_time',
          date_range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')].join(' ~ '),
          vessel_id: null
        },
        dateRangeType: 'dueto_arrive_time',
        dateRangeTypes: [
          {id: 'dueto_arrive_time', name: 'Estimated Arrival Time'},
          {id: 'arrived_time', name: 'Actual Arrival Time'},
          {id: 'dueto_depart', name: 'Estimated Departure Time'},
          {id: 'departed_time', name: 'Actual Departure Time'},
        ]
      };
    },
    computed: {
      voyageDateRangeForApi () {
        return [...this.dates].sort().join(' ~ ')
      },
      dateRangeText () {
        return this.dates.map((d) => moment(d, 'YYYY-MM-DD').format('DD-MM-YYYY')).join(' ~ ')
      },
    },
    methods: {
      async ensureVesselLoaded(vesselId) {
        if (!vesselId) return null;
        
        const existingVessel = _.find(this.vessels, {id: vesselId});
        if (existingVessel) {
          return existingVessel;
        }
        
        try {
          const response = await this.$api.vessels.show(vesselId);
          const vessel = response.vessel;
          
          if (!_.find(this.vessels, {id: vesselId})) {
            this.vessels.push(vessel);
            if (!_.find(this.vesselNames, {id: vesselId})) {
              this.vesselNames.push(vessel);
            }
          }
          
          return vessel;
        } catch (err) {
          console.error('Failed to load vessel:', err);
          return null;
        }
      },
      async navigateOperation(jobType, voyage) {
        const vessel = await this.ensureVesselLoaded(voyage.vessel_id) ||
                      _.find(this.vessels, {id: voyage.vessel_id});
        
        if (!vessel) {
          this.$store.dispatch('setAlert', {
            status: 'error',
            show: true,
            message: 'Failed to load vessel information',
          });
          return;
        }
        
        const hasBillingParty = vessel.card_id && Array.isArray(vessel.card_id) && vessel.card_id.length > 0;
        if (!hasBillingParty) {
          this.$store.dispatch('setAlert', {
            status: 'error',
            show: true,
            message: 'Please assign a billing party to the vessel',
          });
          return;
        }
        
        const hasPrincipal = vessel.principal_cards && Array.isArray(vessel.principal_cards) && vessel.principal_cards.length > 0;
        if (!hasPrincipal) {
          this.$store.dispatch('setAlert', {
            status: 'error',
            show: true,
            message: 'Please assign a principal to the vessel',
          });
          return;
        }

        const eta = voyage.arrived_time || voyage.dueto_arrive_time;
        const etd = voyage.departed_time || voyage.dueto_depart;
        this.$api.operations.checkVesselOverlap(voyage.vessel_id, eta, etd)
          .then((response) => {
            if (response.has_overlap) {
              if (confirm(`Job already exists #${response.job_name} created by ${response.created_by_name}, do you want to create a new job?`)) {
                this.card_id = vessel.principal_cards[0].id;
                this.$router.push({
                  name: 'port calls',
                  query: {
                    createMode: jobType,
                    vesselId: voyage.vessel_id,
                    customerId: this.card_id,
                    eta: eta,
                    etd: etd,
                  },
                });
              }
            } else {
              this.card_id = vessel.principal_cards[0].id;
              this.$router.push({
                name: 'port calls',
                query: {
                  createMode: jobType,
                  vesselId: voyage.vessel_id,
                  customerId: this.card_id,
                  eta: eta,
                  etd: etd,
                },
              });
            }
          });
      },
      applyFilter(filterObj) {
        this.filters = Object.assign(this.filters, filterObj);
        if (this.filters.vessel_id === null || this.filters.vessel_id === '') {
          delete this.filters.vessel_id;
        }
        this.getVoyages(this.filters);
      },
      getVoyages() {
        this.loading = true;
        this.$api.vessel_voyages.index(this.filters)
          .then((response) => {
            const columnsToFormat = [
              'dueto_arrive_time',
              'arrived_time',
              'dueto_depart',
              'departed_time'
            ];
            this.items = response.vesselVoyages.map(obj => {
              Object.keys(obj).forEach(key => {
                if (obj[key] && columnsToFormat.includes(key)) {
                  obj['formatted_' + key] = moment(obj[key]).tz('Singapore').format('DD-MM-YYYY LT');
                }
              });
              return obj;
            });
            this.loading = false;
          }).catch((err) => {
            this.loading = false;
            this.$store.dispatch('setAlert', {
              status: 'error',
              show: true,
              message: err.message,
            });
          });
      },
      populateCards() {
        this.$api.cards.index()
          .then((response) => {
            this.customers = response.cards;
          }).catch((err) => {
            this.$store.dispatch('setAlert', {
              status: 'error',
              show: true,
              message: err.message,
            });
          });
      },
      onVesselSearch() {
        const searchValue = this.vesselSearch || '';
        
        if (this.vesselSearchTimeout) {
          clearTimeout(this.vesselSearchTimeout);
        }
        this.vesselSearchTimeout = setTimeout(() => {
          this.getVessels();
        }, 500);
      },
      getVessels() {
        this.vesselLoading = true;
        const params = {
          page: 1,
          per_page: 100
        };
        
        const searchValue = this.vesselSearch ? String(this.vesselSearch).trim() : '';
        if (searchValue) {
          params.search = searchValue;
        } else {
          params.per_page = 20;
        }
        
        this.$api.vessels.dropdown(params)
          .then(async (response) => {
            this.vesselNames = response.vessels;
            this.vessels = response.vessels;
            this.vesselNames = await ensureSelectedVesselInList({
              vesselId: this.vesselName,
              vesselList: this.vesselNames,
              existingVessels: this.vessels,
              existingFilteredVessels: this.vesselNames,
              loadVesselFn: (id) => this.ensureVesselLoaded(id)
            });
            this.vesselLoading = false;
          }).catch((err) => {
            this.vesselLoading = false;
            this.$store.dispatch('setAlert', {
              status: 'error',
              show: true,
              message: err.message,
            });
          });
      },
    },
    created() {
      this.getVoyages();
      this.getVessels();
      this.populateCards();
    },
  };
</script>
<style>
  #dateRangePicker {
    .v-btn--active {
      background-color: #273978 !important;
      border-color: #273978 !important;
    }
  }
</style>